var render = function render(){var _vm=this,_c=_vm._self._c;return _c('login-selo',{scopedSlots:_vm._u([{key:"formulario",fn:function(){return [_c('login-form')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }